"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class AuthenticationApi extends runtime.BaseAPI {
    /**
     * Login operatore banca a partire da token jwt restituito dai sistemi Banco Desio
     */
    apiAuthenticationLoginAdminGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userToken === null || requestParameters.userToken === undefined) {
                throw new runtime.RequiredError('userToken', 'Required parameter requestParameters.userToken was null or undefined when calling apiAuthenticationLoginAdminGet.');
            }
            const queryParameters = {};
            if (requestParameters.userToken !== undefined) {
                queryParameters['userToken'] = requestParameters.userToken;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Authentication/login-admin`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TokenDtoFromJSON(jsonValue));
        });
    }
    /**
     * Login operatore banca a partire da token jwt restituito dai sistemi Banco Desio
     */
    apiAuthenticationLoginAdminGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiAuthenticationLoginAdminGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Login operatore banca a partire da token jwt restituito dai sistemi Banco Desio
     */
    apiAuthenticationLoginAdminSsoPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const consumes = [
                { contentType: 'application/x-www-form-urlencoded' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.adminToken !== undefined) {
                formParams.append('adminToken', requestParameters.adminToken);
            }
            const response = yield this.request({
                path: `/api/Authentication/login-admin-sso`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ErrorResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     * Login operatore banca a partire da token jwt restituito dai sistemi Banco Desio
     */
    apiAuthenticationLoginAdminSsoPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiAuthenticationLoginAdminSsoPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Login dell\'utente Frontend a partire dal token rivcevuto via email
     */
    apiAuthenticationLoginUserGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.tokenEmail === null || requestParameters.tokenEmail === undefined) {
                throw new runtime.RequiredError('tokenEmail', 'Required parameter requestParameters.tokenEmail was null or undefined when calling apiAuthenticationLoginUserGet.');
            }
            const queryParameters = {};
            if (requestParameters.tokenEmail !== undefined) {
                queryParameters['tokenEmail'] = requestParameters.tokenEmail;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Authentication/login-user`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TokenDtoFromJSON(jsonValue));
        });
    }
    /**
     * Login dell\'utente Frontend a partire dal token rivcevuto via email
     */
    apiAuthenticationLoginUserGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiAuthenticationLoginUserGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     *  (Auth roles: Admin,User)
     */
    apiAuthenticationUserInfoGetRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Authentication/user-info`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.UserDtoFromJSON(jsonValue));
        });
    }
    /**
     *  (Auth roles: Admin,User)
     */
    apiAuthenticationUserInfoGet() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiAuthenticationUserInfoGetRaw();
            return yield response.value();
        });
    }
}
exports.AuthenticationApi = AuthenticationApi;
